import { LandingPageBannerCombinedProps } from './types';

const usePresenter = (props: LandingPageBannerCombinedProps): LandingPageBannerCombinedProps => {
  return props;
};

export default usePresenter;
